module.exports = __webpack_public_path__ + "static/media/whatsapp4.a0e62375.png";